import React from "react";
import { LANGS, useT } from "../lib/i18n";

export default function LanguageSwitcher({ variant = "footer" }) {
  const { lang, setLang, t } = useT();

  if (variant === "compact") {
    return (
      <div className="inline-flex items-center gap-1 bg-white border border-gray-300" data-testid="lang-switcher-compact">
        {LANGS.map((l) => (
          <button
            key={l.code}
            onClick={() => setLang(l.code)}
            className={`px-2 py-1 text-base leading-none transition ${lang === l.code ? 'bg-gray-900' : 'hover:bg-gray-100'}`}
            aria-label={l.label}
            title={l.label}
            data-testid={`lang-${l.code}`}
          >
            <span aria-hidden="true">{l.flag}</span>
          </button>
        ))}
      </div>
    );
  }

  return (
    <div data-testid="lang-switcher">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-gray-400 mb-3">{t("footer.language")}</p>
      <div className="inline-flex bg-white border border-gray-300">
        {LANGS.map((l) => {
          const active = lang === l.code;
          return (
            <button
              key={l.code}
              onClick={() => setLang(l.code)}
              className={`flex items-center gap-2 px-3.5 py-2 text-xs font-bold uppercase tracking-[0.15em] transition border-r border-gray-300 last:border-r-0 ${active ? 'bg-gray-900 text-white' : 'text-gray-700 hover:bg-gray-100'}`}
              data-testid={`lang-${l.code}`}
              aria-pressed={active}
            >
              <span aria-hidden="true" className="text-base leading-none">{l.flag}</span>
              <span className="hidden sm:inline">{l.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
